import apiInstance from '../../utils/axios/apiInstance';
import authInstance from '../../utils/axios/authInstance';
import {encodeData} from '../../utils/url';

export const getNews = (page: number, per_page: number, category: string, search: string, admin?: boolean) => {
  const data : any = {
    page: page,
    per_page: per_page,
    category: category,
    title: search
  };
  const params = encodeData(data);

  return admin ? apiInstance.get(`/admin/news?${params}`) : authInstance.get(`/news?${params}`);
}

export const getSingleNews = (id: string, admin?: boolean) => {
  return admin ? apiInstance.get(`/admin/news/${id}`) : authInstance.get(`/news/${id}`)
}

export const createNewsService = (data: object) => {
  return apiInstance.post('/news', data);
}

export const editNewsService = (data: any, id: string) => {
  const {assigned_to, task_id} = data;

  const endpoint = assigned_to && task_id ? `/admin/news/${id}` : `/news/${id}`;

  return apiInstance.patch(endpoint, data);
}

export const deleteNewsService = (id: string) => {
  return apiInstance.delete(`/admin/news/${id}`);
}

export const getMostReadNews = (page: number, per_page: number) => {
  const data : any = {
    page: page,
    per_page: per_page
  };
  const params = encodeData(data);
  return apiInstance.get(`/home-most-read-news?${params}`);
};


// Get Most Read News By Category
export const getMostReadNewsByCategory = (category: string, unique_id: string, page: number, per_page: number) => {
  const data = {
    category: category,
    unique_id: unique_id,
    page: page,
    per_page: per_page
  };
  const params = encodeData(data);
  return authInstance.get(`/most-read-news-by-category?${params}`);
}